/* Interaction layer: announcement rotator, slideshow, mobile nav, PDP variants, cart drawer.
   Written for this theme; replaces the source storefront's compiled bundle. */
(function () {
  'use strict';
  var fmt = null;
  try {
    fmt = new Intl.NumberFormat(window.WL_LOCALE || 'en-GB', {
      style: 'currency', currency: window.WL_CURRENCY_CODE || 'GBP'
    });
  } catch (e) { fmt = null; }
  var money = function (cents) {
    var v = Math.round(cents) / 100;
    return fmt ? fmt.format(v) : '\u00A3' + v.toFixed(2);
  };
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- announcement rotator ---------- */
  function initAnnouncement() {
    $$('.announcement').forEach(function (bar) {
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var i = 0, timer;
      var go = function (n) {
        items[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      };
      var start = function () { timer = setInterval(function () { go(i + 1); }, 4500); };
      var stop  = function () { clearInterval(timer); };
      var prev = $('.announcement__nav--prev', bar);
      var next = $('.announcement__nav--next', bar);
      if (prev) prev.addEventListener('click', function () { stop(); go(i - 1); start(); });
      if (next) next.addEventListener('click', function () { stop(); go(i + 1); start(); });
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ---------- slideshow ---------- */
  function initSlideshows() {
    $$('.slideshow').forEach(function (el) {
      var slides = $$('.slideshow__slide', el);
      if (slides.length < 2) return;
      var i = 0, delay = (parseFloat(el.getAttribute('data-autoplay')) || 5) * 1000, timer;
      var go = function (n) {
        slides[i].classList.remove('is-selected');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-selected');
      };
      var start = function () { timer = setInterval(function () { go(i + 1); }, delay); };
      el.addEventListener('mouseenter', function () { clearInterval(timer); });
      el.addEventListener('mouseleave', start);
      // swipe
      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
      start();
    });
  }

  /* ---------- mobile nav ---------- */
  function initNav() {
    var burger = $('.header__burger'), nav = $('.header__nav');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- testimonial track arrows ---------- */
  function initTesti() {
    var track = $('.testi__track');
    if (!track) return;
    var step = function () {
      var card = $('.testi__item', track);
      return card ? card.getBoundingClientRect().width + 16 : 300;
    };
    var prev = $('[data-testi-prev]'), next = $('[data-testi-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });
  }

  /* ---------- cart drawer ---------- */
  var Cart = {
    el: null,
    open: function () { if (this.el) this.el.classList.add('is-open'); },
    close: function () { if (this.el) this.el.classList.remove('is-open'); },
    render: function (cart) {
      if (!this.el) return;
      var body = $('.drawer__items', this.el);
      var foot = $('.drawer__total-value', this.el);
      var count = $$('.header__count');
      if (!cart.items.length) {
        body.innerHTML = '<p class="drawer__empty">Your cart is empty.</p>';
      } else {
        body.innerHTML = cart.items.map(function (it) {
          return '<div class="drawer__item">' +
            '<img src="' + (it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=132' : '') + '" alt="" width="72" height="96">' +
            '<div><div>' + it.product_title + '</div>' +
            '<div style="opacity:.65">' + (it.variant_title || '') + '</div>' +
            '<div>' + it.quantity + ' × ' + money(it.final_price) + '</div></div></div>';
        }).join('');
      }
      if (foot) foot.textContent = money(cart.total_price);
      count.forEach(function (c) { c.textContent = cart.item_count; });
    },
    refresh: function () {
      var self = this;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.render(c); return c; });
    },
    add: function (id, qty) {
      var self = this;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { return self.refresh(); })
        .then(function () { self.open(); });
    }
  };

  function initDrawer() {
    Cart.el = $('.drawer');
    if (!Cart.el) return;
    $$('.drawer__scrim, .drawer__close').forEach(function (n) {
      n.addEventListener('click', function () { Cart.close(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
    $$('.js-cart-open').forEach(function (n) {
      n.addEventListener('click', function (e) { e.preventDefault(); Cart.refresh().then(function () { Cart.open(); }); });
    });
    Cart.refresh();
  }

  /* ---------- PDP ---------- */
  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;
    var data;
    try { data = JSON.parse($('#wl-product-json').textContent); } catch (e) { return; }
    var chosen = {};
    (data.options || []).forEach(function (o, idx) {
      var first = (data.variants.find(function (v) { return v.available; }) || data.variants[0]);
      chosen[idx] = first ? first.options[idx] : null;
    });

    var mainImg = $('.pdp__main img', root);
    $$('.pdp__thumbs img', root).forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.getAttribute('data-full') || t.src; }
        $$('.pdp__thumbs img', root).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    function findVariant() {
      return data.variants.find(function (v) {
        return Object.keys(chosen).every(function (k) { return v.options[k] === chosen[k]; });
      });
    }
    function availableFor(idx, value) {
      return data.variants.some(function (v) {
        if (v.options[idx] !== value) return false;
        return Object.keys(chosen).every(function (k) {
          return parseInt(k, 10) === idx || v.options[k] === chosen[k];
        }) && v.available;
      });
    }
    function sync() {
      var v = findVariant();
      $$('.pdp__value', root).forEach(function (b) {
        var idx = parseInt(b.getAttribute('data-option-index'), 10);
        var val = b.getAttribute('data-value');
        b.setAttribute('aria-pressed', chosen[idx] === val ? 'true' : 'false');
        b.disabled = !availableFor(idx, val);
      });
      var priceEl = $('.pdp__price', root);
      var atc = $('.pdp__atc', root);
      var idInput = $('[name="id"]', root);
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = '<span>' + money(v.price) + '</span>' +
            (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
        }
        if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to cart' : 'Sold out'; }
        if (v.featured_image && mainImg) mainImg.src = v.featured_image.src;
        if (history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      } else if (atc) {
        atc.disabled = true; atc.textContent = 'Unavailable';
      }
    }
    $$('.pdp__value', root).forEach(function (b) {
      b.addEventListener('click', function () {
        chosen[parseInt(b.getAttribute('data-option-index'), 10)] = b.getAttribute('data-value');
        sync();
      });
    });
    var form = $('.pdp__form', root);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = findVariant();
        if (!v || !v.available) return;
        var btn = $('.pdp__atc', root);
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        Cart.add(v.id, 1).then(function () { sync(); });
      });
    }
    sync();
  }

  function init() {
    initAnnouncement(); initSlideshows(); initNav(); initTesti(); initDrawer(); initProduct();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.WLCart = Cart;
})();
